export { default } from './StaleIcon';
